import { ButtonHTMLAttributes, DetailedHTMLProps } from 'react';

interface Props extends DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {}

export const FullWidthButton = ({ className, children, ...rest }: Props) => {
  return (
    <button className={['btn btn-full-width d-flex py-3 px-0 w-100', className].filter((p) => p).join(' ')} {...rest}>
      <span className='flex-grow-1 text-truncate'>{children}</span>
      <i className='align-self-center fas fa-arrow-right' />
    </button>
  );
};
